import { TextField, TextFieldProps } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";

export interface FormFieldTextFieldProps {
  name: string;
  label: string;
  control: any;
  rules?: any;
  onBlur?: () => void;
}

export const FormFieldTextField = ({
  name,
  label,
  control,
  rules,
  onBlur,
  ...props
}: FormFieldTextFieldProps & TextFieldProps) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label={label}
          {...props}
          error={!!error}
          helperText={error?.message}
          onBlur={(event) => {
            field.onBlur();
            if (onBlur) {
              onBlur(event);
            }
          }}
        />
      )}
    />
  );
};
